import { CHECK_TYPE_KEYS, CHECK_TYPE_LABELS, type CheckTypeKey } from "../../api/pricelist";
import type { LimitsEnrichItem, LimitsEnrichItemPayload } from "../../api/limitsEnrichItem";
import { formatPricelistPrice } from "../../utils/pricelistFormat";

export interface EnrichForm {
  checkType: CheckTypeKey;
  amount: string;
  price: string;
  active: boolean;
}

export const CHECK_TYPE_OPTIONS = CHECK_TYPE_KEYS.map((value) => ({
  value,
  label: CHECK_TYPE_LABELS[value],
}));

export const emptyEnrichForm = (): EnrichForm => ({
  checkType: "siteCheck",
  amount: "",
  price: "",
  active: true,
});

export const enrichToForm = (item: LimitsEnrichItem): EnrichForm => ({
  checkType: item.checkType,
  amount: item.amount != null ? String(item.amount) : "",
  price: item.price != null ? String(item.price) : "",
  active: item.active !== false,
});

export const toEnrichPayload = (
  form: EnrichForm
): LimitsEnrichItemPayload => ({
  checkType: form.checkType,
  amount: Number(form.amount),
  price: Number(form.price),
  active: form.active,
});

export const validateEnrichForm = (form: EnrichForm): string | null => {
  const amount = Number(form.amount);
  if (
    !form.amount.trim() ||
    !Number.isFinite(amount) ||
    amount < 10 ||
    !Number.isInteger(amount)
  ) {
    return "Укажите размер пакета (целое число ≥ 10)";
  }

  const price = Number(form.price);
  if (!form.price.trim() || !Number.isFinite(price) || price < 0) {
    return "Укажите неотрицательную цену пакета";
  }

  return null;
};

export const enrichTypeLabel = (checkType: CheckTypeKey | string): string =>
  CHECK_TYPE_LABELS[checkType as CheckTypeKey] ?? checkType;

export const enrichActiveLabel = (active?: boolean): string =>
  active === false ? "Неактивен" : "Активен";

export const formatEnrichAmount = (amount?: number): string => {
  if (amount == null || !Number.isFinite(amount)) return "—";
  return String(amount);
};

export const formatEnrichPrice = (price?: number): string => {
  if (price == null || !Number.isFinite(price)) return "—";
  return formatPricelistPrice(price);
};
